import { Component, OnInit,Input, ViewChild, ElementRef } from '@angular/core';
import { ModalController,NavController,AlertController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service'

@Component({
  selector: 'app-specification-attributes',
  templateUrl: './specification-attributes.page.html',
  styleUrls: ['./specification-attributes.page.scss'],
})
export class SpecificationAttributesPage implements OnInit {
  spec:any = {};
  // title="Add"
  @Input() specification:any;
  @Input() index:any;
  @Input() title:any;

  specs;

  @ViewChild('customInput', { static: false }) customInput!: ElementRef;
  
  constructor(private alertcntrl : AlertController,public modal:ModalController,public db:DataService,public navCtrl:NavController) { }

  ngOnInit() {

    // if(this.specification){
      this.specification = this.db.specification_data;
      let value = JSON.stringify(this.specification);
      this.spec = JSON.parse(value)
      console.log(this.spec);
    // }

  }

 async delete_combo(){

    this.specs.map(async (res,index) =>{
      if(index == this.index){
        let alert = await this.alertcntrl.create({
          header: 'Confirm',
          message: 'Do you really want to Delete?',
          buttons: [
            {
              text: 'No',
              role: 'cancel'
            },
            {
              text: 'Yes',
              handler: () => {
                this.specs.splice(index,1);
              }
            }
          ]
        })
        await alert.present();
        // console.log(data,index,type)
        
        
      }
      this.modal.dismiss();
    })
  }

  nav_back(){
    this.navCtrl.navigateBack(['addproduct'])
  }

  

  attr_Change(data){
    console.log(data);
    this.spec.attribute = data.name;
    // this.db.specifications_attributes.map((res:any) => {
    //   if(res.attribute_name  == data.detail.value){
    //     // console.log(res)
    //     this.spec.attribute = res.name
    //   }
    // })
  }


  grp_Change(data){
    console.log(data);
    this.spec.spec_group_name1 = data.name;
  
    //  this.db.specifications_group.map((res:any) => {
    //   if(res.specification_group_name == data.detail.value ){
    //     // console.log(res)
    //     this.spec.spec_group_name1 = res.name;
    //   }
    // })
  }

  error_msg =  false;
  async post_data(){
    if(!this.spec.options || this.spec.options == ''){
      this.error_msg = true;
    }else{
      let value ={
        spec_group_name:this.spec.spec_group_name,
        spec_group_name1: this.spec.spec_group_name1,
        specification_attribute:this.spec.specification_attribute,
        attribute : this.spec.attribute,
        options:this.spec.options
      }
      await this.modal.dismiss({datas:value});
    }
  }

  change(eve){
    if(this.spec.options){
     this.error_msg = false;
    }else{
      this.error_msg = true;
    }
  }

  get_dropdown(eve){
    console.log(eve);
  }

  focusof() {
    this.customInput?.nativeElement?.focus();
  }
  

}
